import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './lightbox-gallery.css';
import './slick.css';
import Slider from 'react-slick';

class Gallery extends Component {
    static propTypes = {
        images: PropTypes.array,
        onExitClick: PropTypes.func.isRequired,
        settings: PropTypes.object,
        imageThumbscreen: PropTypes.element,
        currentImageCounter: PropTypes.element,
        slideIndex: PropTypes.number.isRequired,
    };

    render() {
        return (
            <div>
                <div className="lightbox" role="dialog" tabIndex="0">
                    <div className="lightbox-content">
                        <div className="lightbox-header u-milk">
                            {this.props.currentImageCounter}
                            <div className="lightbox-buttons u-pr16 u-display-inline-block u-float-right">
                                <button
                                    className="u-milk button button--flat"
                                    onClick={this.props.onExitClick}
                                    type="button"
                                >
                                    <svg
                                        className="u-valign-middle"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        width="18"
                                    >
                                        <path
                                            d="M2 2l14 14M16 2L2 16"
                                            stroke="#fff"
                                            strokeWidth="3"
                                        />
                                    </svg>
                                    <span className="u-valign-middle u-ml8">
                                        Lukk
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="lightbox-body clickable u-ma0 noselect">
                            <div
                                className="lightbox-image-wrapper"
                                style={{ maxWidth: 1200, maxHeight: 800 }}
                            >
                                <div>
                                    <Slider {...this.props.settings}>
                                        {this.props.images.map((image, i) => (
                                            <div key={`slide-img-${i}`}>
                                                <img
                                                    alt={image.description}
                                                    src={image.image.urls.large}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '60vh',
                                                        margin: 'auto',
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                                <p
                                    aria-hidden
                                    className="u-text-center u-milk u-t4 u-ph32"
                                >
                                    {this.props.images[this.props.slideIndex]
                                        .description || ''}
                                </p>
                            </div>
                        </div>
                        <div className="lightbox-focustrap" tabIndex="0" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;
